import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import {HOSTNAME, LargeDataAnalyticsHostname} from "../Configs/Domain";



export const fetchTimeSeriesData = createAsyncThunk(
    'timeSeries/fetchTimeSeriesData',
    async({symbols, startDate, endDate}, { getState, rejectWithValue})=>{
      const url = `${HOSTNAME}/timeseries/fetch?symbols=${symbols.join(',')}&sd=${startDate}&ed=${endDate}`;
      try{
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        console.log(data)
        return { data };
      } catch (error) {
        return rejectWithValue(error.toString());
      }
    }
)



export const getTimeSeriesMetric = createAsyncThunk(
    'timeSeries/getTimeSeriesMetric',
    async({symbols, targetSymbol, startDate, endDate, metric, window}, { getState, rejectWithValue})=>{
      let url = `${LargeDataAnalyticsHostname}/metrics/relative/${metric}?`;
      url += `features=${symbols.join(',')}&`;
      url += `target=${targetSymbol}&`;
      if (startDate) url += `start_date=${startDate}`;
      if (endDate) url += `&end_date=${endDate}`;
      if (window) url += `&window=${window}`;

      try{
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        return data;
      } catch (error) {
        return rejectWithValue(error.toString());
      }
    }
)





export const fetchSimulationData = createAsyncThunk(
  'simulations/fetchData',
  async ({ modelName, symbols, endDate, nTrials, nSteps, nSamples, startDate='2018-01-01' }, { rejectWithValue }) => {
    try {
      // Construct the URL with query parameters
      let url = `${LargeDataAnalyticsHostname}/simulations/${modelName}?`;
      url += `symbols=${encodeURIComponent(symbols.join(','))}&`;
      url += `sd=${startDate}&`;
      url += `ed=${endDate}&`;
      url += `n_trials=${nTrials}&`;
      url += `n_steps=${nSteps}&`;
      url += `n_samples=${nSamples}`;

      // Use fetch or any other HTTP client that you prefer
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      return { modelName, data };
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);



export const getSimulationV2 = createAsyncThunk(
  'simulations/getSimulationV2',
  async ({
    years,
    timeStepsPerYear,
    initialValue,
    nPaths,
    targetAnnualReturn,
    targetAnnualVolatility,
    events,
    nSamples,
    lowerPercentile,
    upperPercentile
  }, { rejectWithValue }) => {
    try {
      const url = `${LargeDataAnalyticsHostname}/simulations/`;

      const body = {
        years,
        time_steps_per_year: timeStepsPerYear,
        initial_value: initialValue,
        n_paths: nPaths,
        target_annual_return: targetAnnualReturn,
        target_annual_volatility: targetAnnualVolatility,
        events,
        n_samples: nSamples,
        lower_percentile: lowerPercentile,
        upper_percentile: upperPercentile
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);



export const fetchBlendedTimeseries = createAsyncThunk(
  'timeSeries/fetchBlended',
  async ({ mapping }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ mapping }).toString();
      const url = `${HOSTNAME}/timeseries/blend?${params}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);
